import { async, types } from '~/utils/typeCreator'

export default types(
  [...async('SEARCH_USERS'), 'CLEAR_STATE'],
  'USERS'
)
